










import { Category } from "@/models/category";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CategoryCard extends Vue {
  @Prop() public readonly category!: Category;

  get imageHeight() {
    const breakpoint = (this as any).$vuetify.breakpoint;

    if (breakpoint.xl) {
      return 600;
    } else if (breakpoint.mdAndUp) {
      return 550;
    }

    return 400;
  }
}
